module.exports = __webpack_public_path__ + "static/media/Style6.41a2bf1c.PNG";